import { useGetRefCrops } from "./vegApl"
import type { RefCropModel } from "./vegApl"
import {toTitleCase} from "../utils/HelperFunction"


const noCrops = [] as RefCropModel[]

// Crops only change when the selected site changes, which is already part of the query key.
export const CROPS_QUERY_CACHE_OPTIONS = {
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 24 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
} as const

const useGetSortedRefCrops = (siteCode?: string) => {    
    const { data = noCrops, ...rest } = useGetRefCrops(siteCode, {
        query: {
            queryKey: ["crops", siteCode],
            ...CROPS_QUERY_CACHE_OPTIONS,
            select: (data) =>
                (data.data as RefCropModel[])
                    .map((d) => ({ ...d, name: toTitleCase(d.name ? d.name : "") }))
                    .sort((a: RefCropModel, b: RefCropModel) => {
                        return a.name && b.name ? a.name.localeCompare(b.name) : 0
                    }),
        },
    })

    return {
        data,
        ...rest,
    }
}

export default useGetSortedRefCrops
